import './variables.css'
import './reset.css'
import './utility.css'
import './animation.css'

export const styles = {
  variables: 'variables.css',
  reset: 'reset.css',
  utility: 'utility.css',
  animation: 'animation.css',
}

export function injectStyles(): void {
  const existingStyles = document.getElementById('prl-styles')
  if (existingStyles) return

  const styleEl = document.createElement('style')
  styleEl.id = 'prl-styles'
  document.head.appendChild(styleEl)
}

export function setTheme(theme: 'light' | 'dark'): void {
  document.documentElement.setAttribute('data-theme', theme)
}

export function getTheme(): string {
  return document.documentElement.getAttribute('data-theme') || 'light'
}

export function toggleTheme(): void {
  const current = getTheme()
  setTheme(current === 'dark' ? 'light' : 'dark')
}

export function setCSSVariable(name: string, value: string): void {
  document.documentElement.style.setProperty(name, value)
}

export function getCSSVariable(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}
